import { Box, Divider, Modal, Stack, Text } from '@mantine/core';
import { TextWithTooltip } from 'src/UI/common/TextWithTooltip';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { AddCalendarsListComponent } from './AddCalendarsListComponent';
import { CalendarsListComponent } from './CalendarsListComponent';
import { useCalendars } from '../hooks/useCalendars';

type Props = {
  opened: boolean;
  close: () => void;
};

export const CalendarConnectionsModal = ({ opened, close }: Props) => {
  const { disconnectedCalendars, connectingCalendars, connectedCalendars } = useCalendars();
  const hasConnectedCalendars = connectedCalendars.length > 0;
  const hasDisconnectedCalendars = disconnectedCalendars.length > 0;
  const hasConnectingCalendars = connectingCalendars.length > 0;

  return (
    <Modal opened={opened} onClose={close} centered size="lg" title="Hook up your calendars">
      <Stack gap={0}>
        <Text size="md" fw={FONT_WEIGHTS.medium} c="gray.10">
          We&apos;ll pull meetings from all connected calendars, prep the agenda, and join on the
          right link. If it&apos;s a{' '}
          <TextWithTooltip tooltip="Recording = client match. If any attendee's email matches a client, we record. Or associate the meeting manually.">
            client meeting
          </TextWithTooltip>
          , we&apos;ll record and help create notes & a report.
        </Text>

        <Box mt="xxxl">
          <AddCalendarsListComponent />
        </Box>

        {hasConnectedCalendars && <Divider my="xxl" color="gray.2" />}
        <CalendarsListComponent filter="CONNECTED" />

        {hasDisconnectedCalendars && <Divider my="xxl" color="gray.2" />}
        <CalendarsListComponent filter="DISCONNECTED" />

        {hasConnectingCalendars && <Divider my="xxl" color="gray.2" />}
        <CalendarsListComponent filter="CONNECTING" />
      </Stack>
    </Modal>
  );
};
